$(document).ready(function () {

  const supportMenu = {
    data: {
      menu: $('.support_menu'),
      open: $('.support_menu__open'),
      close: $('.support_menu__close')
    },
    
    changeMenu: () => {
      let _this = supportMenu.data;
    
      if (_this.menu.hasClass('active')) {
        _this.menu.removeClass('active');
      } else {
        _this.menu.addClass('active');   
      }       
    },

    init: () => {
  	  let _this = supportMenu;
  
      _this.data.open.on('click', () => {
        _this.changeMenu();
      });
      _this.data.close.on('click', () => {
        _this.changeMenu();
      });
    }
  }
  supportMenu.init();

  $('.desk--version #button_search').click(function(event){
      event.preventDefault();
     var searchVal = $.trim( $('.desk--version #q').val() ); 
    window.location.href = 'https://www.chemtechsci.com/search?type=product&q=*'+searchVal+'*';
   
  })
  
});